import { useEffect, useRef } from "react";
import { useTracking } from "./useTracking";

export const useTrackAccessSection = (
  sectionClass: string,
  eventCategory: string
) => {
  const { sendEvent } = useTracking();

  const hasSeen = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector(
        sectionClass
      ) as HTMLElement | null;

      if (!element) return;

      if (window.scrollY >= element.offsetTop && !hasSeen.current) {
        hasSeen.current = true;

        sendEvent("section_viewed", {
          event_category: eventCategory,
          event_action: "view",
          value: 1,
        });
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [sectionClass, eventCategory, sendEvent]);
};
